import {BaseNationalRegisterNumberValidator} from './validator';

export {NationalRegisterNumberDirective} from './directive';
export {NationalRegisterNumberPipe} from './pipe';

export const NATIONAL_REGISTER_NUMBER_VALIDATORS = [BaseNationalRegisterNumberValidator];
